export default __webpack_public_path__ + "static/078-ee8b4ea7789c68810514b66373aebd94.jpg";